import * as React from 'react';

export interface SandboxOwnProps {

}

export interface SandboxStateProps {

}

export interface SandboxDispatchProps {
  readonly enterSandbox: () => void;
}

export type SandboxProps = SandboxOwnProps & SandboxStateProps & SandboxDispatchProps;

export class Sandbox extends React.PureComponent<SandboxProps> {

  public componentDidMount() {
    this.props.enterSandbox();
  }

  public render() {
    return <React.Fragment>
      <h1>Hola Amigos!</h1>
      </React.Fragment>;
  }
}
